import React, { useEffect, useState } from 'react';
import ClassroomModal from './ClassroomModal';

interface TeacherNoteModalProps {
  isOpen: boolean;
  initialNote?: string | null;
  entryLabel?: string;
  busy?: boolean;
  onClose: () => void;
  onSubmit: (note: string) => void | Promise<void>;
}

const TeacherNoteModal: React.FC<TeacherNoteModalProps> = ({
  isOpen,
  initialNote = '',
  entryLabel,
  busy,
  onClose,
  onSubmit,
}) => {
  const [note, setNote] = useState(initialNote || '');

  useEffect(() => {
    if (isOpen) setNote(initialNote || '');
  }, [isOpen, initialNote]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    await onSubmit(note.trim());
  };

  return (
    <ClassroomModal isOpen={isOpen} title="Teacher note" onClose={onClose} width={480}>
      <form onSubmit={handleSubmit} className="cd-modal-form">
        {entryLabel ? <p className="cd-modal-hint">{entryLabel}</p> : null}
        <label className="cd-field">
          <span className="cd-field-label">Note</span>
          <textarea
            className="cd-input cd-textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Something to remember for next class…"
            rows={5}
            autoFocus
            maxLength={500}
            disabled={busy}
          />
        </label>
        <p className="cd-modal-hint">
          Optional. Great for reveal moments — e.g. “Ask them about the dragon moat.”
        </p>
        <div className="cd-modal-actions">
          <button type="button" className="cd-btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="submit" className="cd-btn cd-btn-primary" disabled={busy}>
            {busy ? 'Saving…' : 'Save note'}
          </button>
        </div>
      </form>
    </ClassroomModal>
  );
};

export default TeacherNoteModal;
